function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*!
 * @license Copyright (c) 2003-2022, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md.
 */
!function (t, e) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = e(require("vue")) : "function" == typeof define && define.amd ? define(["vue"], e) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.CKEditor = e(require("vue")) : t.CKEditor = e(t.Vue);
}(window, function (t) {
  return function (t) {
    var e = {};

    function n(i) {
      if (e[i]) return e[i].exports;
      var r = e[i] = {
        i: i,
        l: !1,
        exports: {}
      };
      return t[i].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
    }

    return n.m = t, n.c = e, n.d = function (t, e, i) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: i
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == _typeof(t) && t && t.__esModule) return t;
      var i = Object.create(null);
      if (n.r(i), Object.defineProperty(i, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var r in t) {
        n.d(i, r, function (e) {
          return t[e];
        }.bind(null, r));
      }
      return i;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 3);
  }([function (e, n) {
    e.exports = t;
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      var n = "object" == _typeof(t) && t && t.Object === Object && t;
      e.a = n;
    }).call(this, n(2));
  }, function (t, e) {
    var n;

    n = function () {
      return this;
    }();

    try {
      n = n || new Function("return this")();
    } catch (t) {
      "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && (n = window);
    }

    t.exports = n;
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var i = n(0),
        r = n.n(i);

    var o = function o(t) {
      var e = _typeof(t);

      return null != t && ("object" == e || "function" == e);
    },
        a = n(1),
        u = "object" == (typeof self === "undefined" ? "undefined" : _typeof(self)) && self && self.Object === Object && self,
        c = a.a || u || Function("return this")(),
        s = function s() {
      return c.Date.now();
    },
        l = /\s/;

    var f = function f(t) {
      for (var e = t.length; e-- && l.test(t.charAt(e));) {
        ;
      }

      return e;
    },
        d = /^\s+/;

    var p = function p(t) {
      return t ? t.slice(0, f(t) + 1).replace(d, "") : t;
    },
        v = c.Symbol,
        h = Object.prototype,
        m = h.hasOwnProperty,
        y = h.toString,
        b = v ? v.toStringTag : void 0;

    var g = function g(t) {
      var e = m.call(t, b),
          n = t[b];

      try {
        t[b] = void 0;
        var i = !0;
      } catch (t) {}

      var r = y.call(t);
      return i && (e ? t[b] = n : delete t[b]), r;
    },
        j = Object.prototype.toString;

    var w = function w(t) {
      return j.call(t);
    },
        O = v ? v.toStringTag : void 0;

    var $ = function $(t) {
      return null == t ? void 0 === t ? "[object Undefined]" : "[object Null]" : O && O in Object(t) ? g(t) : w(t);
    };

    var _ = function _(t) {
      return null != t && "object" == _typeof(t);
    };

    var E = function E(t) {
      return "symbol" == _typeof(t) || _(t) && "[object Symbol]" == $(t);
    },
        S = /^[-+]0x[0-9a-f]+$/i,
        x = /^0b[01]+$/i,
        T = /^0o[0-7]+$/i,
        D = parseInt;

    var N = function N(t) {
      if ("number" == typeof t) return t;
      if (E(t)) return NaN;

      if (o(t)) {
        var e = "function" == typeof t.valueOf ? t.valueOf() : t;
        t = o(e) ? e + "" : e;
      }

      if ("string" != typeof t) return 0 === t ? t : +t;
      t = p(t);
      var n = x.test(t);
      return n || T.test(t) ? D(t.slice(2), n ? 2 : 8) : S.test(t) ? NaN : +t;
    },
        I = Math.max,
        M = Math.min;

    var C = function C(t, e, n) {
      var i,
          r,
          a,
          u,
          c,
          l,
          f = 0,
          d = !1,
          p = !1,
          v = !0;
      if ("function" != typeof t) throw new TypeError("Expected a function");

      function h(e) {
        var n = i,
            o = r;
        return i = r = void 0, f = e, u = t.apply(o, n);
      }

      function m(t) {
        return f = t, c = setTimeout(b, e), d ? h(t) : u;
      }

      function y(t) {
        var n = t - l;
        return void 0 === l || n >= e || n < 0 || p && t - f >= a;
      }

      function b() {
        var t = s();
        if (y(t)) return g(t);
        c = setTimeout(b, function (t) {
          var n = e - (t - l);
          return p ? M(n, a - (t - f)) : n;
        }(t));
      }

      function g(t) {
        return c = void 0, v && i ? h(t) : (i = r = void 0, u);
      }

      function j() {
        var t = s(),
            n = y(t);

        if (i = arguments, r = this, l = t, n) {
          if (void 0 === c) return m(l);
          if (p) return clearTimeout(c), c = setTimeout(b, e), h(l);
        }

        return void 0 === c && (c = setTimeout(b, e)), u;
      }

      return e = N(e) || 0, o(n) && (d = !!n.leading, a = (p = "maxWait" in n) ? I(N(n.maxWait) || 0, e) : a, v = "trailing" in n ? !!n.trailing : v), j.cancel = function () {
        void 0 !== c && clearTimeout(c), f = 0, i = l = r = c = void 0;
      }, j.flush = function () {
        return void 0 === c ? u : g(s());
      }, j;
    };

    var K = {
      name: "ckeditor",
      created: function created() {
        var _window = window,
            t = _window.CKEDITOR_VERSION;

        if (t) {
          var _t$split$map = t.split(".").map(Number),
              _t$split$map2 = _slicedToArray(_t$split$map, 1),
              _e = _t$split$map2[0];

          _e < 34 && console.warn("The <CKEditor> component requires using CKEditor 5 in version 34 or higher.");
        } else console.warn('Cannot find the "CKEDITOR_VERSION" in the "window" scope.');
      },
      render: function render(t) {
        return t(this.tagName);
      },
      props: {
        editor: {
          type: Function,
          default: null
        },
        value: {
          type: String,
          default: ""
        },
        config: {
          type: Object,
          default: function _default() {
            return {};
          }
        },
        tagName: {
          type: String,
          default: "div"
        },
        disabled: {
          type: Boolean,
          default: !1
        }
      },
      data: function data() {
        return {
          $_instance: null,
          $_lastEditorData: {
            type: String,
            default: ""
          }
        };
      },
      mounted: function mounted() {
        var _this = this;

        var t = Object.assign({}, this.config);
        this.value && (t.initialData = this.value), this.editor.create(this.$el, t).then(function (e) {
          _this.$_instance = e, _this.$_setUpEditorEvents(), _this.value !== t.initialData && e.setData(_this.value), _this.disabled && e.enableReadOnlyMode("Integration Sample"), _this.$emit("ready", e);
        }).catch(function (t) {
          console.error(t);
        });
      },
      beforeDestroy: function beforeDestroy() {
        this.$_instance && (this.$_instance.destroy(), this.$_instance = null), this.$emit("destroy", this.$_instance);
      },
      watch: {
        value: function value(t) {
          this.$_instance && t !== this.$_lastEditorData && this.$_instance.setData(t);
        },
        disabled: function disabled(t) {
          t ? this.$_instance.enableReadOnlyMode("Integration Sample") : this.$_instance.disableReadOnlyMode("Integration Sample");
        }
      },
      methods: {
        $_setUpEditorEvents: function $_setUpEditorEvents() {
          var _this2 = this;

          var t = this.$_instance,
              e = C(function (e) {
            var n = _this2.$_lastEditorData = t.getData();

            _this2.$emit("input", n, e, t);
          }, 300, {
            leading: !0
          });
          t.model.document.on("change:data", e), t.editing.view.document.on("focus", function (e) {
            _this2.$emit("focus", e, t);
          }), t.editing.view.document.on("blur", function (e) {
            _this2.$emit("blur", e, t);
          });
        }
      }
    };

    var R = r.a ? r.a.version : i.version,
        _R$split$map = R.split(".").map(function (t) {
      return parseInt(t, 10);
    }),
        _R$split$map2 = _slicedToArray(_R$split$map, 1),
        k = _R$split$map2[0];

    if (2 !== k) throw new Error("The CKEditor plugin works only with Vue 2.x. For more information, please refer to https://ckeditor.com/docs/ckeditor5/latest/builds/guides/integration/frameworks/vuejs-v2.html");
    var P = {
      install: function install(t) {
        t.component("ckeditor", K);
      },
      component: K
    };
    e.default = P;
  }]).default;
});